import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';
import prop from 'ramda/src/prop';
import uniqBy from 'ramda/src/uniqBy';
import Avatar from '@components/@core/Avatar';
import EditDropdown from '@components/EditDropdown';
import { convertUrl } from '~/services/util';

const Card = ({ avatar, date, description, loginUser, title, special = '', stats, user, onClick, onSelect }) => {
    const options = stats?.flag ? ['Unflag spam'] : ['Flag spam'];

    return (
        <div className="card mt-3" onClick={onClick}>
            <p className="dsl-b22 bold">{special}</p>
            <div className="d-h-between">
                <div className="d-flex ai-center">
                    <Avatar url={avatar} className="mr-2" size="tiny" isSponsored={true} />
                    <div>
                        <p className="dsl-m12 mb-1">
                            {user?.first_name} {user?.last_name}
                        </p>
                        <p className="dsl-b12 mb-0">{user?.profile?.company}</p>
                    </div>
                </div>
                <div className="d-flex">
                    <span className="dsl-m12">{date}</span>
                    {loginUser?.id && loginUser.id !== user.id && <EditDropdown className="ml-3" options={options} onChange={onSelect} />}
                </div>
            </div>
            <p className="dsl-b18 text-400 mt-4">{title}</p>
            <div className="w-100 blog-detail" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    );
};

const Recent = ({ data, onClick, onSetFlag }) => {
    if (!data.data || data.data.length === 0) return <p className="dsl-b16 card">No blogs published</p>;

    const loginUser = useSelector((state) => state.app.user?.community_user) || {};
    const posts = uniqBy(prop('id'), data.data);

    const handleSetFlag = (item) => (e) => {
        const payload = { contentId: item.id, flag: 'spam' };
        if (onSetFlag) onSetFlag(payload);
    };

    return posts.map((item, index) => (
        <Card
            key={index}
            user={item?.author}
            avatar={convertUrl(item?.author_avatar)}
            date={moment(item.created_at).format('MMM DD, YY')}
            loginUser={loginUser}
            title={item.name}
            stats={item.stats}
            description={item.data?.body}
            onClick={() => onClick(item)}
            onSelect={handleSetFlag(item)}
        />
    ));
};

Recent.propTypes = {
    data: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        from: PropTypes.number,
        per_page: PropTypes.number,
    }),
};

Recent.defaultProps = {
    data: {
        current_page: 0,
        data: [],
        from: 0,
        per_page: 0,
    },
};

export default Recent;
